import templateUrl from "emun.customer/customer-dashboard-header.htm";
import controller from "emun.customer/customer-dashboard-header.controller";

export default {
  bindings: {
    customer: "<"
  },
  controller,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  }
};
